
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Die zweite Welle`}</h2>
    <p>{`Auch in der zweiten Welle von Anfang Juni 2020 bis Ende Februar 2021 sind grenznahe Gemeinden in der Südschweiz überdurchschnittlich vom Virus betroffen. Gleichzeitig bilden sich neue Cluster – in der Ostschweiz, zum Beispiel. Und besonders viele Infektionen verzeichnet die Romandie. Gemäss BAG-Zahlen gibt es in der zweiten Welle mehr als 500’000 Corona-Infektionen und 8000 Tote. In vielen Kantonen kommen die Intensivstationen an den Anschlag.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;